import { createSlice } from '@reduxjs/toolkit';
import { io } from 'socket.io-client';

/**
 * {
 * message: string,
 * id: string,
 * progress: number | undefined,
 * title: string | undefined,
 * timeout: number
 * cancellable: boolean,
 * }
 */

export const workflowSlice = createSlice({
    name: 'workflow',
    initialState: {
        workflow: undefined,
        loaded: false,
    },
    reducers: {
        updateProperty: (state, action) => {
            state.workflow[action.payload.property] = action.payload.value;
        },
        setWorkflow: (state, action) => {
            state.workflow = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    updateProperty,
    setWorkflow,
} = workflowSlice.actions;

export default workflowSlice.reducer;
